import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField, DateTimeField, enumField } from './util';
import { File } from './file';
import { Tournament } from './tournament';

export enum LeagueNewsType {
  text = 1,
  video
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    title: 'title',
    datetime: 'datetime',
    preview_text: 'previewText',
    detail_text: 'detailText',
    picture: 'picture',
    cover: 'cover',
    mobile_picture: 'mobilePicture',
    is_main: 'isMain',
    tournaments: 'tournaments',
    type: 'type',
    video_link: 'videoLink',
    tag: 'tag',
  },
  relation: {
    datetime: DateTimeField,
    picture: File,
    cover: File,
    mobilePicture: File,
    tournaments: listField(Tournament),
    type: enumField(LeagueNewsType),
  }
})
export class LeagueNews extends BaseModel {
  id: number;
  title: string;
  datetime: Date;
  previewText: string;
  detailText: string;
  picture: File;
  cover: File;
  mobilePicture: File;
  isMain: boolean;
  tournaments: Tournament[];
  type: LeagueNewsType;
  videoLink: string;
  tag: string;

  @ToFrontHook
  static toFront(data: any): any {
    return undefined;
  }

  @ToBackHook
  static toBack(data: any): any {}
}
